import type { HostInfo } from '@casa/bridge';

// The page and the menu background, taken from the legacy MAUI app: Resources/Styles/Colors.xaml and
// the XAML of MainPage and SideMenu; the chrome's own colours after them (specs/look.md). Chakra's
// `casa.*` tokens are made from these (ui/chakra.tsx); canvases take them as they are. The look of
// the tiles is in `@casa/tiles`.

export const PAGE_BACKGROUND = '#000000';
export const MENU_BACKGROUND = '#202020';
export const MENU_BUTTON_COLOR = '#ffffff';
/** The save button while there are changes that are not saved (edit mode; not in the legacy app). */
export const UNSAVED_COLOR = '#ffa500';
/** The current screen's mark, edit mode, the main button (look LK-1, LK-4). */
export const ACCENT_COLOR = '#2563eb';
/** Edit mode's group in the menu: the accent, faint. */
export const ACCENT_TINT = 'rgba(37, 99, 235, 0.18)';
/** A screen's square in the menu, and rows in the chrome. */
export const RAISED_BACKGROUND = '#2e2e2e';
/** Lines between groups. */
export const LINE_COLOR = '#3a3a3a';
/** Text and icons that are there but not chosen. */
export const MUTED_COLOR = '#a0a0a0';
/**
 * A settings group's title, border, and the lines between its rows (look LK-13, the owner,
 * 2026-10-27): Chakra's defaults (`fg.muted`, `border.muted`) made the groups hard to see on black.
 */
export const GROUP_TITLE_COLOR = '#60a5fa';
export const GROUP_BORDER_COLOR = '#3f3f46';
export const GROUP_DIVIDER_COLOR = '#27272a';

/**
 * Locale for numbers: the operating system's regional format, as the legacy app used (.NET current
 * culture). The shell passes it in `casaHost.locale`; without it the engine's default is used,
 * which follows the language setting instead.
 */
export const NUMBER_LOCALE: string | undefined = (globalThis as { casaHost?: HostInfo }).casaHost?.locale;
